import { gql } from 'Utils/apolloClient'
import UserPaymentMethodsDataFragment from './userPaymentMethodsDataFragment'

const paymentMethodsQuery = gql`
  query User($id: ID, $reservationUuid: ID, $withReservation: Boolean!) {
    isEnvTest
    user(id: $id) {
      ...userPaymentMethodsData
      id
      installmentsPendingToPay {
        pricing {
          camperTotal {
            display
          }
        }
        dueOn
        id
        links {
          accountInstallmentUrl
        }
      }
      installmentsPendingToPayCount
      reservation(uuid: $reservationUuid) @include(if: $withReservation) {
        campground {
          name
        }
        isAutopay
        schedule {
          dayOrdinalized
          id
          hasPaymentMethodStripeFailed
          installmentNextToPay {
            dueOn
            pricing {
              camperTotal {
                display
              }
            }
          }
          paymentMethodAuto {
            ... on PaymentMethodStripeAch {
              accountHolder
              brand
              isVerified
              lastFour
            }
            ... on PaymentMethodStripeCard {
              brand
              brandIconKey
              expDate
              lastFour
            }
          }
          recurringType
          startsOn
        }
      }
    }
  }

  ${UserPaymentMethodsDataFragment}
`

export default paymentMethodsQuery
